import React, {Component} from 'react';
import {Container} from 'react-bootstrap';
import {FormattedHTMLMessage} from 'react-intl';
import {FormattedMessage} from 'react-intl';

class About extends Component {

	render() {
		return (
				<section className="page mt-4">
					<Container>
						<h2 className="page-title">
							<FormattedMessage id="nav.link.features" defaultMessage="Features"/>
						</h2>
						<div className="page-content mt-2">
							<FormattedHTMLMessage id="about.text"/>
						</div>
					</Container>
				</section>
		);
	}
}

export default About;
